export default "__VITE_ASSET__BjbVhIMH__"